module.exports = __webpack_public_path__ + "img/5.61329ff1.jpg";